// Vendor Libs
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import {startsWith} from 'lodash';

// Components
import Icon from './icon';

// Styles
import './tag.scss';

export default class Tag extends Component {
    getClass() {
        const {children, className, icon, small, type} = this.props;

        return classnames(
            {
                tag: true,
                button_link: type === 'link',
                button_small: small,
                'button_with-icon': icon,
                'button_icon-only': icon && !children,
            },
            className
        );
    }

    getProps() {
        const {disabled, style, title, type, value} = this.props;

        return {
            className: this.getClass(),
            disabled,
            style,
            title,
            onClick: this.handleDeleteClick,
            type,
            value,
        };
    }

    getIconClass() {
        const {iconClassName} = this.props;

        return classnames(
            {
                'button--icon': true,
            },
            iconClassName
        );
    }

    getIconProps() {
        const {disabled, title, type, value} = this.props;

        return {
            className: this.getClass(),
            disabled,
            onClick: this.handleDeleteClick,
            title,
            type,
            value,
        };
    }

    handleDeleteClick = () => {
        const {handleDeleteClick, id} = this.props;

        handleDeleteClick(id);
    };

    renderIcon() {
        return <Icon className={this.getIconClass()} fontAwesomeType="times" {...this.getIconProps()} />;
    }

    render() {
        const {children} = this.props;

        return (
            <tag {...this.getProps()}>
                {startsWith(children, ' ') ? `'${children}'` : children}
                {this.renderIcon()}
            </tag>
        );
    }
}

Tag.propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    disabled: PropTypes.bool,
    handleDeleteClick: PropTypes.func,
    icon: PropTypes.string,
    iconClassName: PropTypes.string,
    id: PropTypes.number,
    small: PropTypes.bool,
    style: PropTypes.object,
    title: PropTypes.string,
    type: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};
